module.exports = __webpack_public_path__ + "img/YellowArrows_top.45ef044f.svg";